import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { createBrowserHistory } from 'history';

// import middleware
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';

// import reducer
import createRootReducer from '../reducers';

export const history = createBrowserHistory();

function configureStore(preLoadedState) {
  // middleware
  const middleware = [routerMiddleware(history), thunk];

  const middlewareEnhancer = applyMiddleware(...middleware);

  const enhancers = [middlewareEnhancer];

  const composedEnhancers = composeWithDevTools(...enhancers);

  return createStore(createRootReducer(history), preLoadedState, composedEnhancers);
}

export default configureStore;
